// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // api_rul: 'http://localhost:8001/api',
  // auth_url: 'http://localhost:8001/auth',
  // api_rul: 'https://trackpayout-v1-backend.contisofttechno.com/api',
  // auth_url: 'https://trackpayout-v1-backend.contisofttechno.com/auth'

  api_rul: 'https://trackpayout-api.esakal.com/api',
  auth_url: 'https://trackpayout-api.esakal.com/auth'


  // api_rul: 'https://trackpayout.contisofttechno.com:80/api',
  // auth_url: 'https://trackpayout.contisofttechno.com:8001/auth',
  //  api_rul: 'https://trackpayout.contisofttechno.com:8013/api', //Test Environment
  //  auth_url: 'https://trackpayout.contisofttechno.com:8013/auth', //Test Environment
  // api_rul: 'https://trackpayout.contisofttechno.com:8017/api',
  // auth_url: 'https://trackpayout.contisofttechno.com:8017/auth',v  
  // api_rul: 'https://trackpayout.contisofttechno.com:8019/api', 
  // auth_url: 'https://trackpayout.contisofttechno.com:8019/auth', 
  // api_rul: 'https://trackpayout.contisofttechno.com:8008/api',
  // auth_url: 'https://trackpayout.contisofttechno.com:8008/auth',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';
// Included with Angular CLI.
